var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-600-113H840V943H-600z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M1.779 9.716a.417.417 0 0 0 0 .568l5.833 6.25a.417.417 0 0 0 .61-.568l-5.18-5.55h15.291a.417.417 0 0 0 0-.833H3.041l5.18-5.549a.42.42 0 0 0 .036-.525L8.2 3.445a.417.417 0 0 0-.589.02Z"
  }))));
};
export default SvgArrowLeft;